// Copyright (c) 2020 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file wisetime/user/type/tag_category_ref.proto (package wisetime.user.type, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wisetime/user/type/tag_category_ref.proto.
 */
export const file_wisetime_user_type_tag_category_ref: GenFile = /*@__PURE__*/
  fileDesc("Cil3aXNldGltZS91c2VyL3R5cGUvdGFnX2NhdGVnb3J5X3JlZi5wcm90bxISd2lzZXRpbWUudXNlci50eXBlIjwKDlRhZ0NhdGVnb3J5UmVmEg8KB3NpdGVfaWQYASABKAkSCgoCaWQYAiABKAkSDQoFbGFiZWwYAyABKAlCMwoaY29tLndpc2V0aW1lLmFwaS51c2VyLnR5cGVCE1RhZ0NhdGVnb3J5UmVmUHJvdG9QAWIGcHJvdG8z");

/**
 * A reference to a legebill.type.TagCategory.
 *
 * @generated from message wisetime.user.type.TagCategoryRef
 */
export type TagCategoryRef = Message<"wisetime.user.type.TagCategoryRef"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * @generated from field: string label = 3;
   */
  label: string;
};

/**
 * Describes the message wisetime.user.type.TagCategoryRef.
 * Use `create(TagCategoryRefSchema)` to create a new message.
 */
export const TagCategoryRefSchema: GenMessage<TagCategoryRef> = /*@__PURE__*/
  messageDesc(file_wisetime_user_type_tag_category_ref, 0);

